import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Alerts from '../../../../prototypes/Alerts';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import EtelAPI from '../../../../api/EtelAPI';
import PageAuthorize from '../../../../security/PageAuthorize';
import EditSectionInput from '../../../../presentation/EditSectionInput';
import EditSectionLabel from '../../../../presentation/EditSectionLabel';
import EditSectionDropdown from '../../../../presentation/EditSectionDropdown';
import Select from 'react-select';
import Overlay from '../../../../presentation/Overlay';
import SpeechTranscriptionsDialog from './SpeechTranscriptionsDialog';


import * as WjGrid from 'wijmo/wijmo.react.grid';
import * as wijmo from 'wijmo/wijmo';

wijmo.setLicenseKey(
  'stage.etelconnections.com|172.16.0.116|dev.etelconnections.com|172.16.2.189|stage.eteconnections.com|172.16.1.15|www.etelconnections.com|172.16.0.112|lv.etelconnections.com|etelconnections.com|www.dev.etelconnections.com|172.16.1.22,854482378799655#B032Sbj9ycu3Wa4NWZu96bjxWZ4VmLldWY4NnI0IyctRkIsIybjVGblRVLFJiOiEmTDJCLiUTN6kTO7gzNzIDO4QTN8IiOiQWSiwSfdtlOicGbmJCLiIjdyIDMyIiOiIXZ6JCLlNHbhZmOiI7ckJye0ICbuFkI1pjIEJCLi4TPBh7RwYjWClUQRFnby9UMrYUcIJEZa5EevlTSzJHepVjdqxEZsl7QxhUS4t6UyFEdPNGbClWMQJHc7Z4Kv2EcG5kQwVzdMd4dIpHMrwWcz8ESONUW4wUQ7tCSBhmMIhzcykGTMpmTlNXMvpXRrd5Qo3ES7NUcPtSM9YHMMBVRJ36MtxUTxx6cBdlM64mUIZDMOdGWYhGZC3EcHdkRSZjZFBFUZ5GZX9ET8tSTMNVe5R7dzhlaYFUc5YVOadUe6ZjZWVDULt4RNBndYJ7U4NTbwckRItUUsF7c42Wc94WVEh7Y4JzRQRmMnJ5QrAnaThWdygVSqdkZaBFRrlHVP3UcrYENzRTOVR5bRJXQ6xka8ZnTqdlcitEcxtWZzhFSqZXaZJkeG3yKFZkSCpkR6QnexYjb43SWH9UbChXRykGTkxETn5UVrlzavIlR0lFNuNkbtZEdIJDSiojITJCLikTO6czN6IUNiojIIJCLwEjM6gDM4gTO0IicfJye35XX3JSSwIjUiojIDJCLi86bpNnblRHeFBCI4VWZoNFelxmRg2Wbql6ViojIOJyes4nI5kkTRJiOiMkIsIibvl6cuVGd8VEIgIXZ7VWaWRncvBXZSBybtpWaXJiOi8kI1xSfis4N8gkI0IyQiwiIu3Waz9WZ4hXRgAydvJVa4xWdNBybtpWaXJiOi8kI1xSfiQjR6QkI0IyQiwiIu3Waz9WZ4hXRgACUBx4TgAybtpWaXJiOi8kI1xSfiMzQwIkI0IyQiwiIlJ7bDBybtpWaXJiOi8kI1xSfiUFO7EkI0IyQiwiIu3Waz9WZ4hXRgACdyFGaDxWYpNmbh9WaGBybtpWaXJiOi8kI1tlOiQmcQJCLiAzMwEDOwAyNxgDMzIDMyIiOiQncDJCLiIjMuEjL6EjLycTMs46bj9ycu3Wa4NWZu96bjxWZ4VmL6VGZuc7d7xSbvNmLz96bpR7Yl9mbvNGblRXZs46bj9ycu3Wa4NWZu96bjxWZ4VmL6xGLyETMuAjL6EjLycTMs46bj9ycu3Wa4NWZu96bjxWZ4VmL7d7dsUTMuEjL6EjLycTMs46bj9ycu3Wa4NWZu96bjVGdl9SZnFGdzxSO8EjLy8iNx8iM7EDLt36YuMnbvlGdjVmbu36YsVGdl9idlRGL6ETMuAjL6EjLtcYM'
);

/**
 * Creates an anchor element containing some content to download a text file.
 *
 * @param {String} content String to write to the file.
 * @param {String} fileName The filename.
 */
function exportFile( content, fileName ) {
  let blob = new Blob( [content], { encoding: 'UTF-8', type: 'text/plain;charset=utf-8' } );
  let element = document.createElement( 'a' );
  element.href = window.URL.createObjectURL( blob );
  element.setAttribute( 'download', fileName );

  element.style.display = 'none';
  document.body.appendChild( element );

  element.click();

  document.body.removeChild( element );
}

class SpeechTranscriptions extends Component {
  constructor( props ) {
    super( props );

    this.state = {
      view: new wijmo.CollectionView( [{ PDNIS: 'Please use search above' }] ),
      viewIndex: 0,
      viewCount: 0,
      pageSize: 50,
      speechTranscriptions: [
        { PDNIS: 'Please use search above' }
      ],
      filters: {
        PDNIS: [],
        START_DATE: '',
        END_DATE: '',
        ANI: '',
        M_UUID: '',
        STRING: '',
      },
      exportType: 0,
      showSpeechTranscriptionsDialog: false,
      selectedTranscription: {},
      loading: false
    };

    this.onHandleChangeExportType = this.onHandleChangeExportType.bind( this );
    this.onHandleChangePDNISFilter = this.onHandleChangePDNISFilter.bind( this );
    this.onHandleChangeFilters = this.onHandleChangeFilters.bind( this );
    this.onHandleKeyPressFilters = this.onHandleKeyPressFilters.bind( this );
    this.onHandleClickFilterButtons = this.onHandleClickFilterButtons.bind( this );
    this.onHandleDoubleClickWijmo = this.onHandleDoubleClickWijmo.bind( this );
    this.onHandleCloseDialog = this.onHandleCloseDialog.bind( this );
    this.onHandleException = this.onHandleException.bind( this );

    this.wijmoPanel = undefined;
    this.interval = undefined;

    this.pdnisOptions = [];

    this.title = 'Speech Transcriptions';
  }

  /****************************************************************************
   * STATE / LIFECYCLE METHODS
   ***************************************************************************/

  componentDidMount() {
    this.alert = new Alerts( this.props.bugsnag, this.props.dispatch );

    this.getPgmTranscriptions( [] ).then( ( pgmTranscriptionsResults ) => {
      for ( let result of pgmTranscriptionsResults ) {
        this.pdnisOptions.push(
          { 'value': result.PDNIS, 'label': result.PDNIS }
        );
      }
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  componentWillUnmount() {
    if ( this.interval ) {
      clearInterval( this.interval );
    }

    this.interval = undefined;
  }

  /****************************************************************************
   * EXCEPTION HANDLING
   ***************************************************************************/

  doLogOff() {
    const { dispatch, auth, history } = this.props;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  onHandleException( e ) {
    const { dispatch, bugsnag } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;

    if ( status === 401 ) {
      alerts.INFO( this.title, 'Your session has expired.', 5000 );
      this.doLogOff();
    } else if ( status === 500 ) {
      alerts.INFO( this.title, e.statusText, 5000 );
    } else {
      if ( e.statusText !== undefined ) {
        alerts.CRITICAL( this.title, e, false );
      } else {
        alerts.CRITICAL( this.title, e );
      }
    }
  }

  /****************************************************************************
   * API CALLS
   ***************************************************************************/

  getData() {
    const params = [
      { PDNIS: this.state.filters.PDNIS.map( ( item ) => { return item.label; } ).join( ',' ) },
      { START_DATE: this.state.filters.START_DATE },
      { END_DATE: this.state.filters.END_DATE },
      { M_UUID: this.state.filters.M_UUID },
      { ANI: this.state.filters.ANI },
      { STRING: this.state.filters.STRING },
      { RETURN_TRANSCRIPTIONS: 0 }  // Load the table without returning any transcriptions to speed up results
    ];

    let loadingStr = 'Loading';
    this.interval = setInterval( () => {
      loadingStr += '.';

      this.setState( {
        view: new wijmo.CollectionView(
          [
            {
              PDNIS: loadingStr,
              CCFILEDATE: loadingStr,
              SERVICES: loadingStr,
              AUDIO_LENGTH: loadingStr,
              ANI: loadingStr,
              M_UUID: loadingStr,
            }
          ] ),
      } );
    }, 1000 );

    this.getSpeechTranscriptions( params ).then( ( speechTranscriptionsResults ) => {
      if ( speechTranscriptionsResults.length === 0 ) {
        speechTranscriptionsResults = [
          {
            PDNIS: `No data for ${this.state.filters.PDNIS.map( ( item ) => { return item.label; } ).join( ',' )}`,
            CCFILEDATE: `No data for ${this.state.filters.START_DATE} - ${this.state.filters.END_DATE}`
          },
        ];
      }

      this.setState( {
        view: new wijmo.CollectionView( speechTranscriptionsResults, { pageSize: this.state.pageSize } ),
        speechTranscriptions: speechTranscriptionsResults,
        loading: false
      }, () => {
        this.setState( {
          viewIndex: this.state.view.pageIndex + 1,
          viewCount: this.state.view.pageCount
        } );

        // Clear the interval when results have already returned
        clearInterval( this.interval );

        this.interval = undefined;
      } );
    } ).catch( ( exception ) => {
      this.setState( {
        speechTranscriptions: [
          {
            PDNIS: `No data for ${this.state.filters.PDNIS.map( ( item ) => { return item.label; } ).join( ',' )}`,
            CCFILEDATE: `No data for ${this.state.filters.START_DATE} - ${this.state.filters.END_DATE}`
          }
        ]
      } );

      this.onHandleException( exception );
    } );
  }

  getPgmTranscriptions( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'speechtranscriptions/pgmtranscription' );

      api.get( params ).then( ( pgmTranscriptionsResults ) => {
        resolve( pgmTranscriptionsResults );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  getSpeechTranscriptions( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'speechtranscriptions' );

      api.get( params ).then( ( speechTranscriptionsResults ) => {
        resolve( speechTranscriptionsResults );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  /****************************************************************************
   * HELPER METHODS
   ***************************************************************************/

  exportData() {
    const params = [
      { PDNIS: this.state.filters.PDNIS.map( ( item ) => { return item.label; } ).join( ',' ) },
      { START_DATE: this.state.filters.START_DATE },
      { END_DATE: this.state.filters.END_DATE },
      { M_UUID: this.state.filters.M_UUID },
      { ANI: this.state.filters.ANI },
      { STRING: this.state.filters.STRING },
      { RETURN_TRANSCRIPTIONS: 1 }  // Exporting data, retrieve the transcriptions to make a TSV file
    ];

    // Hold the current view to revert back to original results after exporting is done
    const currentView = this.state.view;

    let loadingStr = 'Exporting';
    this.interval = setInterval( () => {
      loadingStr += '.';

      this.setState( {
        view: new wijmo.CollectionView(
          [
            {
              PDNIS: loadingStr,
              CCFILEDATE: loadingStr,
              SERVICES: loadingStr,
              AUDIO_LENGTH: loadingStr,
              ANI: loadingStr,
              M_UUID: loadingStr,
            }
          ] ),
      } );
    }, 1000 );

    this.getSpeechTranscriptions( params ).then( ( speechTranscriptionsResults ) => {
      /*
        0 = Column formatted TSV
        1 = Non-formatted Timestamps TSV
      */
      let exportType = this.state.exportType;
      let exportString = exportType === 0
        ? 'M_UUID\tPDNIS\tANI\tCCFILEDATE\tSERVICE\tTRANSCRIPTION\n'
        : 'M_UUID\tPDNIS\tANI\tCCFILEDATE\tSERVICE\tCALLER_AGENT\tTIMESTAMP\tTRANSCRIPTION\n';

      for ( let speechTranscription of speechTranscriptionsResults ) {
        const pdnis = speechTranscription.PDNIS;
        const ccfiledate = speechTranscription.CCFILEDATE;
        const m_uuid = speechTranscription.M_UUID;
        const ani = speechTranscription.ANI;
        const service = speechTranscription.SERVICES;
        let transcription = speechTranscription.PARSED_TRANSCRIPTION;

        if ( exportType !== 0 ) {
          const transcriptionLines = transcription.split( '\n' );
          let currentSpeaker = '';
          let transcript = '';
          let timestamp = '';
          let rowData = '';

          for ( let i = 0; i < transcriptionLines.length; ++i ) {
            const line = transcriptionLines[i];
            const speakerLine = line.startsWith( ' ' ) ? line.substring( 42 ).trim() : line.substring( 0, 40 ).trim();

            if ( speakerLine ) {
              if ( isNaN( speakerLine ) ) {
                transcript += speakerLine + ' ';
              } else {
                if ( i !== 0 ) {
                  transcript = transcript.trim();
                  rowData += `${m_uuid}\t${pdnis}\t${ani}\t${ccfiledate}\t${service}\t${currentSpeaker}\t${timestamp}\t${transcript}\n`;
                }

                timestamp = speakerLine;
                transcript = '';
              }
            }

            currentSpeaker = line.startsWith( ' ' ) ? 'Agent' : 'Caller';
          }
          rowData += `${m_uuid}\t${pdnis}\t${ani}\t${ccfiledate}\t${service}\t${currentSpeaker}\t${timestamp}\t${transcript}\n`;

          exportString += rowData;
        } else {
          exportString += `${m_uuid}\t${pdnis}\t${ani}\t${ccfiledate}\t${service}\t${transcription}\n`;
        }
      }

      exportFile( exportString, 'speech_transcriptions' );

      clearInterval( this.interval );
      this.interval = undefined;

      this.setState( {
        view: currentView,
        loading: false
      } );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  /**
   * Updates the wijmo grid/page based on which button is clicked to show the
   * next results.
   *
   * Example taken from:
   * https://www.grapecity.com/wijmo/demos/Core/CollectionView/CreatingViews/Paging/react
   *
   * @param {Object} target The button that was clicked.
   */
  updateViewPager( target ) {
    let view = this.state.view;

    let btn = wijmo.closest( target, 'button' ), id = btn ? btn.id : '';
    switch ( id ) {
      case 'btnFirst':
        view.moveToFirstPage();
        break;
      case 'btnPrev':
        view.moveToPreviousPage();
        break;
      case 'btnNext':
        view.moveToNextPage();
        break;
      case 'btnLast':
        view.moveToLastPage();
        break;
      default:
        break;
    }

    this.setState( {
      viewIndex: view.pageIndex + 1,
      viewCount: view.pageCount
    } );
  }

  getExportTypes() {
    return [
      { id: 0, text: 'Column Formatted TSV' },
      { id: 1, text: 'Non-formatted Timestamps TSV' },
    ];
  }

  /****************************************************************************
   * EVENT HANDLERS
   ***************************************************************************/

  onHandleChangeExportType( e ) {
    this.setState( {
      exportType: parseInt( e.target.value, 10 )
    } );
  }

  /**
   * Updates the filter selection for PDNIS.
   * 
   * @param {Array<Object>} items Array of objects that looks similar to:
   * [
   *   { 'value': '9960939', 'label': '9960939' },
   *   { 'value': '9960949', 'label': '9960949' }
   * ]
   */
  onHandleChangePDNISFilter( items ) {
    this.setState( {
      filters: {
        PDNIS: items,
        START_DATE: this.state.filters.START_DATE,
        END_DATE: this.state.filters.END_DATE,
        ANI: this.state.filters.ANI,
        M_UUID: this.state.filters.M_UUID,
        STRING: this.state.filters.STRING,
      }
    } );
  }

  onHandleChangeFilters( e ) {
    const updatedFilters = { ...this.state.filters };
    updatedFilters[e.target.column] = e.target.value;

    this.setState( {
      filters: updatedFilters
    } );
  }

  onHandleKeyPressFilters( e ) {
    if ( e === 'Enter' ) {
      if ( !this.state.loading ) {
        this.setState( {
          loading: true
        }, () => {
          this.getData();
        } );
      }
    }
  }

  onHandleClickFilterButtons( e ) {
    if ( this.state.loading ) {
      return;
    }

    const button = e.target.id;

    this.setState( {
      loading: true
    }, () => {
      switch ( button ) {
        case 'search':
          this.getData();
          break;
        case 'export':
          this.exportData();
          break;
        default:
          break;
      }
    } );
  }

  onHandleDoubleClickWijmo( e ) {
    const selectedTranscription = this.wijmoPanel.control.selectedItems[0];

    this.setState( {
      selectedTranscription: selectedTranscription,
      showSpeechTranscriptionsDialog: true
    } );
  }

  onHandleCloseDialog( e ) {
    this.setState( {
      selectedTranscription: {},
      showSpeechTranscriptionsDialog: false
    } );
  }

  /****************************************************************************
   * RENDERS
   ***************************************************************************/

  renderPageHeader() {
    return (
      <div
        className='speech-transcriptions-page-header'
      >
        Speech Transcriptions
      </div>
    );
  }

  renderFilters() {
    return (
      <div className='speech-transcriptions-filter-container'>
        <div className='speech-transcriptions-filters'>
          <div className='speech-transcriptions-filter-inputs'>
            <span className='speech-transcriptions-filter-input-group'>
              <EditSectionLabel className='speech-transcriptions-filter-group-label' Text='PDNIS' />
              <Select className='speech-transcriptions-select-dropdown'
                name={'PDNIS-dropdown'}
                placeholder={'PDNIS'}
                value={this.state.filters.PDNIS}
                options={this.pdnisOptions}
                multi={true}
                menuIsOpen={false}
                clearable={false}
                scrollMenuIntoView={true}
                onChange={this.onHandleChangePDNISFilter}
              />
            </span>
            <span className='speech-transcriptions-filter-input-group'>
              <EditSectionLabel className='speech-transcriptions-filter-group-label' Text='START DATE' />
              <EditSectionInput id='speech-transcriptions-START-DATE-input' columnName='START_DATE' placeholder={'YYYYMMDD'} value={this.state.filters.START_DATE} onChanged={this.onHandleChangeFilters} onKeyPress={this.onHandleKeyPressFilters} />
            </span>
            <span className='speech-transcriptions-filter-input-group'>
              <EditSectionLabel className='speech-transcriptions-filter-group-label' Text='END DATE' />
              <EditSectionInput id='speech-transcriptions-END-DATE-input' columnName='END_DATE' placeholder={'YYYYMMDD'} value={this.state.filters.END_DATE} onChanged={this.onHandleChangeFilters} onKeyPress={this.onHandleKeyPressFilters} />
            </span>
            <span className='speech-transcriptions-filter-input-group'>
              <EditSectionLabel className='speech-transcriptions-filter-group-label' Text='TEXT' />
              <EditSectionInput id='speech-transcriptions-STRING-input' columnName='STRING' value={this.state.filters.STRING} onChanged={this.onHandleChangeFilters} onKeyPress={this.onHandleKeyPressFilters} />
            </span>
            <span className='speech-transcriptions-filter-input-group'>
              <EditSectionLabel className='speech-transcriptions-filter-group-label' Text='ANI' />
              <EditSectionInput id='speech-transcriptions-ANI-input' columnName='ANI' value={this.state.filters.ANI} onChanged={this.onHandleChangeFilters} onKeyPress={this.onHandleKeyPressFilters} />
            </span>
            <span className='speech-transcriptions-filter-input-group'>
              <EditSectionLabel className='speech-transcriptions-filter-group-label' Text='MUUID' />
              <EditSectionInput id='speech-transcriptions-M_UUID-input' columnName='M_UUID' value={this.state.filters.M_UUID} onChanged={this.onHandleChangeFilters} onKeyPress={this.onHandleKeyPressFilters} styles={{ width: '300px' }} />
            </span>
          </div>
          <div className='speech-transcriptions-filters-buttons'>
            <span className='speech-transcriptions-filter-button-group'>
              <button className='speech-transcriptions-filter-search-button' id='search' onClick={this.onHandleClickFilterButtons}>Search</button>
            </span>
          </div>
        </div>
      </div>
    );
  }

  renderBody() {
    return (
      <div
        className='speech-transcriptions-body'
        onDoubleClick={this.onHandleDoubleClickWijmo}
      >
        <WjGrid.FlexGrid
          ref={( panel ) => this.wijmoPanel = panel}
          autoGenerateColumns={false}
          allowDragging={0}
          itemsSource={this.state.view}
          selectionMode='CellRange'
          autoClipboard={true}
          allowAddNew={false}
          allowDelete={false}
          allowSorting={true}
          style={{ /* height: '100%',  width: '100%', overflow: 'auto' */ }}
        >
          <WjGrid.FlexGridColumn header='PDNIS' binding='PDNIS' width={200} isReadOnly={true} />
          <WjGrid.FlexGridColumn header='CCFILEDATE' binding='CCFILEDATE' width={200} format='D' isReadOnly={true} />
          <WjGrid.FlexGridColumn header='SERVICES' binding='SERVICES' width={200} isReadOnly={true} />
          <WjGrid.FlexGridColumn header='AUDIO LENGTH' binding='AUDIO_LENGTH' width={200} isReadOnly={true} />
          <WjGrid.FlexGridColumn header='ANI' binding='ANI' width={200} isReadOnly={true} />
          <WjGrid.FlexGridColumn header='MUUID' binding='M_UUID' width='1*' isReadOnly={true} />
        </WjGrid.FlexGrid>
      </div>
    );
  }

  render() {
    const selectedTranscription = { ...this.state.selectedTranscription };
    const showSpeechTranscriptionsDialog = this.state.showSpeechTranscriptionsDialog;
    const showOverlay = showSpeechTranscriptionsDialog;

    return (
      <PageAuthorize groups={['Administrators', 'Operations', 'Management']}>
        <div
          className='speech-transcriptions-container'
        >
          {
            this.renderPageHeader()
          }
          {
            this.renderFilters()
          }
          {
            <div className='speech-transcription-pagination' onClick={e => this.updateViewPager( e.target )}>
              <div id='pager' className='wj-control wj-content wj-pager'>
                <div className='wj-input-group'>
                  <span className='wj-input-group-btn'>
                    <button id='btnFirst' type='button' className='wj-btn wj-btn-default'>
                      <span className='wj-glyph-left'></span>
                      <span className='wj-glyph-left'></span>
                    </button>
                  </span>
                  <span className='wj-input-group-btn'>
                    <button id='btnPrev' type='button' className='wj-btn wj-btn-default'>
                      <span className='wj-glyph-left'></span>
                    </button>
                  </span>
                  <input id='spanCurrent' disabled={true} type='text' className='wj-form-control' value={`${this.state.viewIndex} of ${this.state.viewCount}`} />
                  <span className='wj-input-group-btn'>
                    <button id='btnNext' type='button' className='wj-btn wj-btn-default'>
                      <span className='wj-glyph-right'></span>
                    </button>
                  </span>
                  <span className='wj-input-group-btn'>
                    <button id='btnLast' type='button' className='wj-btn wj-btn-default'>
                      <span className='wj-glyph-right'></span>
                      <span className='wj-glyph-right'></span>
                    </button>
                  </span>
                </div>
              </div>
              {
                this.state.speechTranscriptions.length > 0
                &&
                ![undefined, null, ''].includes( this.state.speechTranscriptions[0].M_UUID )
                &&
                <div>
                  <EditSectionLabel className='speech-transcriptions-export-format-label' Text='Export Format:' />
                  <EditSectionDropdown value={this.state.exportType} options={this.getExportTypes()} onChanged={this.onHandleChangeExportType} />
                  <button className='speech-transcriptions-filter-export-button' id='export' onClick={this.onHandleClickFilterButtons}>Export</button>
                </div>
              }
            </div>
          }
          {
            this.renderBody()
          }
          {
            showSpeechTranscriptionsDialog
            &&
            <SpeechTranscriptionsDialog
              show={showSpeechTranscriptionsDialog}
              selectedTranscription={selectedTranscription}
              onClose={this.onHandleCloseDialog}
            />
          }
          {
            showOverlay
            &&
            <Overlay show={showOverlay} />
          }
        </div>
      </PageAuthorize>
    );
  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( SpeechTranscriptions )
);



// WEBPACK FOOTER //
// ./src/content/enterprise/speechtranscriptions/components/SpeechTranscriptions.js